/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.optins.rpc.OptinsAvailabilityRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const checkOptinAvailabilityRpc = {
  serviceName: 'com.hubspot.optins.rpc.OptinsAvailabilityRpc',
  rpcName: 'checkOptinAvailability',
  auth: 'app',
  fingerprint: 'buP2vG_ZIzx4sJHHGCjwy5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const checkMultiOptinAvailabilityRpc = {
  serviceName: 'com.hubspot.optins.rpc.OptinsAvailabilityRpc',
  rpcName: 'checkMultiOptinAvailability',
  auth: 'app',
  fingerprint: 'BRxKusWf6S0kh4DEB0ptzpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateTargetStateRpc = {
  serviceName: 'com.hubspot.optins.rpc.OptinsAvailabilityRpc',
  rpcName: 'updateTargetState',
  auth: 'app',
  fingerprint: 'TAGBbYzvka11mi1fZ1xtjpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const setHubLevelOverrideRpc = {
  serviceName: 'com.hubspot.optins.rpc.OptinsAvailabilityRpc',
  rpcName: 'setHubLevelOverride',
  auth: 'app',
  fingerprint: 'eZzXOLHE7Wl1mi1fZ1xtjpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteHubLevelOverrideRpc = {
  serviceName: 'com.hubspot.optins.rpc.OptinsAvailabilityRpc',
  rpcName: 'deleteHubLevelOverride',
  auth: 'app',
  fingerprint: '3WTx-EUs1_Z1mi1fZ1xtjpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};